export const frenchTranslations = {
  enterPatientID: "Saisissez l'identifiant du patient:",
  info: "Info",
  info1: "Bonjour mon cher.e ami.e.",
  info2: "Bienvenue sur la merveilleuse application qu'est cette beauté. Elle a été développée par la fantastique équipe des Fishy Funksticks. Voici la base:",
  info3: "Vous pouvez appuyer sur un bouton sur la page d'accueil pour ajouter votre demande au système. Elle est classée selon son importance et nous la confions à l'une de nos adorables infirmières qui viendra vous apporter toute l'aide dont vous aurez besoin. Vous pouvez ajouter vos informations dans le menu des options, ainsi que modifier l'apparence du site.",
  info4:  "Voilà, c'est tout. À plus.",

  LanguagePref:  "PLangue préférée...",

  logout:  "Se déconnecter",

  nurse:  "INFIRMIÈRE/IER",
  patient:  "PATIENT/E",
  iama: "Je suis un/e...",
  submit: "SOUMETTRE",


  username:  "Saisissez votre nom d'utilisateur:",
  password:  "Entrer le mot de passe:",
  invalidcred: "Identifiants invalides, réessayez!",
  invalidval: "Veuillez entrer des données valides.",

  patientid:  "Identité du patient", 
  requesttype:  "Type de demande", 
  extrainfo: "Informations supplémentaires",
  done:  "Marquer comme Fait",

  yournexttask:  "Votre prochaine tâche",
  break:  "Je suis en pause",
  schedulebreak:  "Horaire de pause",

  timeblockedout:  "Quand voulez-vous partir?",
  leave:  "Partir:",
  return:  "Retour:",

  neurodiverse:  "Neurodivers",
  nonverbal:  "Nonverbal",
  ESL:  "Anglais en seconde langue",
  other:  "Other",
  dark:  "SOMBRE",
  light:  "CLAIR",
  options:  "Choix",
  Iam:  "Je suis...",

  food:  "Obtenir de la nourriture",
  water:  "Obtenir de l'eau",
  toilet :  "Aller aux toilettes",
  meds:  "Obtenir des médicaments",
  assist:  "Aide physique",
  emergency:  "Urgence",
  settings:  "Paramètres",
  infoicon:  "Info",

  extrainfo:  "Souhaitez-vous ajouter des informations supplémentaires ?",
  sendrequest:  "Envoyer la demande",
  adddeets:  "Ajouter plus de détails ici",
};
